

export const getAlreadySession = () => {
    return localStorage.getItem('session_expired') === 'expired';
}


